import React from 'react'
import ConfigStore from './../stores/config';
import AppStore from './../stores/app';
import TourStore from './../stores/tour';

export const StoreContext = React.createContext({
  config: ConfigStore,
  app: AppStore,
  tour: TourStore
})